export default __webpack_public_path__ + "static/media/DSC00606.5a31780d.jpg";